var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('div',[_c('span'),_vm._v(" "+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }